import React from "react";
import { FaArrowRight, FaCheckCircle } from "react-icons/fa";
import aboutImg from "../../image/about.jpeg";
import "../../css/about.css";

function About({ setShowModal }) {
  const highlights = [
    "Attractive Franchise Opportunities",
    "Complete Partner Support",
    "Reliable Supply Network"
  ];

  return (
    <section id="about" className="py-3 py-lg-5" style={{ backgroundColor: '#fdfdfd' }}>

      <div className="container">
        <div className="row align-items-center g-5">
          {/* Left Content */}
          <div className="col-lg-6">
            <div className="mb-4">
              <span className="badge rounded-pill px-3 py-2 mb-3" style={{ backgroundColor: 'rgba(232, 98, 41, 0.1)', color: '#e86229', fontSize: '14px', fontWeight: '700', letterSpacing: '1px' }}>
                ABOUT CHEMO BIOLOGICAL
              </span>
              <h3 className="fw-bold display-5 mb-4" style={{ color: 'rgb(1 110 112)', lineHeight: '1.2' }}>
                Chemo Biological Limited – Best PCD Pharma Franchise Company in India
              </h3>
              <div style={{ width: "80px", height: "5px", backgroundColor: "#e86229", borderRadius: "3px" }}></div>
            </div>

            <p
              className="text-secondary mb-3"
              style={{ lineHeight: "1.7", color: "black" }}
            >
              Chemo Biological Limited is a leading <strong>PCD Pharma Franchise Company in India</strong> with <strong>43+ years of experience</strong> in delivering quality healthcare solutions. We offer <strong>500+ high-quality pharmaceutical products</strong> across <strong>25+ complete ranges</strong>, including Derma, Gynae, Ortho, and more. Our <strong>PCD Pharma Franchise opportunities</strong> provide genuine <strong>monopoly rights</strong>, reliable products, and complete marketing support. With a strong network of <strong>500+ distributors</strong> and the trust of <strong>1000+ satisfied customers</strong>, we are committed to helping our partners achieve sustainable business growth. Partner with us for quality products, trusted service, and excellent pharmaceutical franchise opportunities.
            </p>

            <div className="mt-5 d-none d-md-block">
              <ul className="list-unstyled d-flex flex-column gap-3" onClick={() => setShowModal(true)}>
                {highlights.map((item, index) => (
                  <li key={index}>
                    <div className="about-list-item d-flex align-items-center justify-content-between p-3 rounded-3 bg-white text-dark fw-bold shadow-sm border border-light">
                      <div className="d-flex align-items-center gap-3">
                        <FaCheckCircle className="about-icon fs-5" />
                        <span style={{ color: '#1a2f55' }}>{item}</span>
                      </div>
                      <FaArrowRight style={{ color: '#ccc' }} />

                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-4 pt-2">
              <button className="btn btn-orange px-4 py-2 fw-bold rounded-pill shadow-sm" onClick={() => setShowModal(true)}>
                Consult an Expert
              </button>
            </div>

          </div>

          {/* Right Content - Image */}
          <div className="col-lg-6 ps-lg-5">
            <div className="position-relative mt-5 mt-lg-0">
              <div className="position-absolute top-0 end-0 rounded-circle" style={{ width: '150px', height: '150px', backgroundColor: 'rgba(232, 98, 41, 0.1)', transform: 'translate(20%, -20%)', zIndex: 0 }}></div>
              <img
                src={aboutImg}
                alt="About Chemo Biological Limited"
                className="img-fluid rounded-4 shadow-lg w-100 object-fit-cover position-relative about-img"
                style={{ border: '1px solid #eee', zIndex: 1 }}
              />
              <div
                className="p-3 p-md-4 mt-4 shadow-lg mx-auto text-white position-relative overflow-hidden"
                style={{
                  background: 'linear-gradient(135deg, #e86229 0%, #c14413 100%)',
                  borderRadius: '20px',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  zIndex: 2,
                  boxShadow: '0 15px 30px rgba(232, 98, 41, 0.2)'
                }}
              >
                <div className="position-absolute top-0 end-0 p-3 opacity-25">
                  <i className="bi bi-award-fill" style={{ fontSize: '5rem' }}></i>
                </div>
                <div className="d-flex align-items-center justify-content-center gap-3 gap-md-4 text-start position-relative z-1">
                  <div>
                    <h2 className="fw-bolder mb-0 display-4 display-sm-3" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.2)' }}>+43</h2>
                  </div>
                  <div style={{ borderLeft: '2px solid rgba(255,255,255,0.3)', height: '60px' }}></div>
                  <div>
                    <h5 className="fw-bold mb-1 text-white" style={{ letterSpacing: '0.5px' }}>Years of Trust</h5>
                    <p className="mb-0 text-white-50 fw-medium" style={{ fontSize: '0.9rem' }}>Excellence in Healthcare</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
